export default "__VITE_ASSET__CEn35CEo__"